import 'bootstrap/js/dist/tab';
import 'bootstrap/js/dist/modal';

import '../../styles/vendors/tingle.min.css';
import '../../styles/theme.scss';

import {focusHash, bindInPageLinks} from '@shopify/theme-a11y';

import {load} from '@shopify/theme-sections';
import '../sections/main-header';

import Basket from '../lib/basket';
import {util} from '../lib/util';
import {discounts} from '../lib/discounts';
import '../lib/fade-in-on-scroll';
import '../lib/slidescroll';
import '../lib/parallax';
import {emailAndZipSubmit} from '../lib/email-and-zip-submit';
import '../lib/panel-press-reviews';
import '../lib/panel-occasion-carousel';
import '../lib/carousel-collection';
import '../lib/carousel-reviews';
import '../lib/carousel-hero';
import '../lib/carousel-product-images';
import '../lib/carousel-bestsellers';
import '../lib/panel-whats-inside';

import {carousel} from '../lib/carousel';

if (window.location.href.indexOf('subscription-flow') === -1) {
  emailAndZipSubmit.init();
}

discounts.init();

carousel.init();
document.addEventListener(
  'carousel:init',
  () => {
    carousel.init();
  },
  false,
);

load(['main-header']);

// Common a11y fixes
focusHash();
bindInPageLinks();

// Apply a specific class to the html element for browser support of cookies.
if (window.navigator.cookieEnabled) {
  document.documentElement.className = document.documentElement.className.replace(
    'supports-no-cookies',
    'supports-cookies',
  );
}

window.basket = new Basket({products: window.products});

const basketInitEvent = new CustomEvent('basket:init', {detail: {response: window.basket}});

document.dispatchEvent(basketInitEvent);

const links = document.links;

for (let i = 0, linksLength = links.length; i < linksLength; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
  }
}

// Capture UTM params
const utmParms = ['utm_source', 'utm_medium', 'utm_term', 'utm_campaign', 'utm_content'];

for (let i = 0, utmsLength = utmParms.length; i < utmsLength; i++) {
  const param = utmParms[i];
  const value = util.getUrlParam(param);
  if (value) {
    window.basket.setUTM(param, value);
  }
}
